// Cadastro do paciente abre em NOVA ABA a partir de telas de trabalho contínuo (fila de
// oportunidades, modal da agenda): sair delas perderia o ponto onde a pessoa parou.
export const patientRegisterUrl = (patientId: string): string => {
  const clinic = new URLSearchParams(window.location.search).get("clinic") || "ninho";
  return `${window.location.origin}/?page=patient-register&id=${patientId}&clinic=${clinic}`;
};

/** A tela atual já é o cadastro do paciente — o atalho abriria a mesma página. */
export const isOnPatientRegisterPage = (): boolean =>
  new URLSearchParams(window.location.search).get("page") === "patient-register";
